<template>
	<div>
		<v-row class="">
			<v-col cols="12" md="4" class="pr-4">
				<v-form ref="add_new_product_form"  lazy-validation class="custome-form" @submit.prevent="addProduct()" >
					<p class="sub-title-text-dark mb-3">{{$lang.PRODUCT_DETAILS}}</p>
					
					<div class="m-t-negative-10">
						<label >{{$lang.PRODUCT_NAME}}</label>
						<v-text-field
						v-model="product_name"
						:placeholder="$lang.PRODUCT_NAME"
						outlined
						dense
						single-line
						:rules="$rules.PRODUCT_NAME"
						></v-text-field>
					</div>	
					<div class="m-t-negative-10">
						<label>{{$lang.MANUFACTURER}}</label>
						<v-combobox
						v-model="manufacturer"
						:items="manufacturer_list"
						item-text="name"
						item-value="id"
						:placeholder="$lang.MANUFACTURER"
						@focus="manufacturerAutoComplete"
						@keydown="manufacturerAutoComplete"
						:search-input.sync="manufacturer_serch_query"
						append-icon="mdi-menu-down"
						single-line
						outlined
						clearable
						dense
						:rules="$rules.MANUFACTURER"
						:loading="manufacturer_loading"
						>
					</v-combobox> 		
				</div>	
				<div class="m-t-negative-10">
					<label>{{$lang.FARMULA}}</label>
					<v-combobox
					v-model="formula"
					:items="formula_list"
					item-text="name"
					item-value="id"
					:placeholder="$lang.FARMULA"
					@focus="formulaAutoComplete"
					@keydown="formulaAutoComplete"
					:search-input.sync="formula_serch_query"
					append-icon="mdi-menu-down"
					single-line
					outlined
					clearable
					dense
					:rules="$rules.FORMULA"
					:loading="formula_loading"
					>
				</v-combobox> 
			</div>
			<div class="m-t-negative-10">
				<label>{{$lang.PRICE}}</label>
				<v-text-field
				v-model="price"
				:placeholder="$lang.PRICE"
				outlined
				maxlength="10"
				dense
				single-line
				:rules="$rules.PRICE"
				></v-text-field>
			</div>

			<div class="m-t-negative-10">
				<label>{{$lang.OFFER}}</label>
				<v-text-field
				v-model="offer"
				:label="$lang.OFFER"
				:placeholder="$lang.OFFER"
				outlined
				maxlength="99"
				dense
				single-line
				></v-text-field>
			</div>
			<div class="mt-3 text-center">
				<v-btn color="primary " type="submit" :loading="btn_loading" >
					<b>{{$lang.CONTINUE}}</b>
				</v-btn>	
			</div>

		</v-form>
	</v-col>
</v-row>
</div>
</template>
<script>
export default {
	data(){
		return{
			manufacturer_serch_query:"",
			manufacturer_loading:false,
			formula_serch_query:"",
			formula_loading:false,
			btn_loading:false,
			is_edit:false,

			product_id:"",

			manufacturer_list:[],
			formula_list:[],

			product_name:"",
			manufacturer:"",
			formula:"",
			offer:"",
			price:"",
		}
	},
	created(){
		/*  show and hide the back btn*/ 
		if (this.$route.name=='edit-product'){
			this.product_id= this.decrypt(this.$route.params.product_id)
			this.getProduct()
		}
	},
	methods:{

		/* fetching  the Manufacturer */ 
		manufacturerAutoComplete(){
			const self=this
			let params={
				"search_query":self.manufacturer_serch_query,
			};	
			self.manufacturer_loading=true;
			const successHandler = (response) => {
				self.manufacturer_list=response.data.manufacturer_list

			};
			const finallyHandler = () => {
				self.manufacturer_loading=false
			};
			self.request_GET( self,self.$urls.MASTER_MANUFACTURER_LIST,params,successHandler,null,null,finallyHandler)
		},
		/* fetching  the formula */ 
		formulaAutoComplete(){

			const self=this
			let params={
				"search_query":self.formula_serch_query,
			};
			self.formula_loading=true;
			const successHandler = (response) => {
				self.formula_list=response.data.formula_list

			};
			const finallyHandler = () => {
				self.formula_loading=false
			};
			self.request_GET( self,self.$urls.MASTER_FORMULA_LIST,params,successHandler,null,null,finallyHandler)
		},
		/* Add and  edit product*/ 
		addProduct(){
			const self=this;
			if (this.$refs.add_new_product_form.validate()==false)
				return false

			console.log(self.formula)


			self.btn_loading=true
			/* adding params*/ 
			var	form = new FormData();
			form.append("name",self.product_name);
			if(self.manufacturer.name)
				form.append("product_manufacturer",self.manufacturer.name);
			else
				form.append("product_manufacturer",self.manufacturer);

			if(self.formula.name)
				form.append("product_formula",self.formula.name);
			else
				form.append("product_formula",self.formula);

			form.append("product_price",self.price);
			form.append("offer",self.offer);

			/*changing url for  edit  */
			let url= this.$urls.CREATE_PRODUCT
			if(self.is_edit){
				url=this.$urls.EDIT_PRODUCT
				form.append("id",self.product_id);

			}

			const successHandler = (response) => {
				if(response.data.success)
					self.$router.push({name:'products'})
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};

			this.request_POST(self,url,form,successHandler,null,null,finallyHandler)
		},
		/* fetching product deails for edit product */ 
		getProduct(){
			const self=this
			this.$store.dispatch('setPageLoader', true)
			let params={
				"id":self.product_id,
			};
			const successHandler = (response) => {
				let data= response.data.data
				self.product_name=data.name
				self.manufacturer=data.product_manufacturer
				self.formula=data.product_formula
				self.offer=data.offer
				self.price=data.product_price
				self.is_edit=true

			};
			const finallyHandler = () => {
				self.$store.dispatch('setPageLoader', false)
			};
			self.request_GET( self,self.$urls.PRODUCT_DETAILS,params,successHandler,null,null,finallyHandler)
		},


	}
}
</script>